module.exports = __webpack_public_path__ + "img/DCR-alt.59af2907.svg";